export default {"src":"/_next/static/media/usdt.8451d078.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};